<template>
	<div class="study">
		<publicHeader></publicHeader>
		<careerHeader :careerNav ="careerNav"></careerHeader>
		<div class="w1200 career_test">
			<div class="career_report_history">
				<router-link :to="{path: '/career_details', query: {id: data.assess_project_data.id}}" class="tc cl_white inline">历史报告 ></router-link>
			</div>
			<div class="career_report_title tc">
				<p class="f26px cl_dark">{{data.assess_project_data.name}}</p>
				<p class="cl_gray mat10">{{data.done_time}}</p>
			</div>
			<div class="career_report_list">
				<div class="practice_title f20px cl_dark">测试简介</div>
				<div class="f16px cl_gray">{{data.assess_project_data.intro}}</div>
			</div>
			<div class="career_report_list">
				<div class="practice_title f20px cl_dark">评测属性</div>
				<div class="tc career_report_item_cont">
					<div class="career_report_item" v-for="(item,index) in data.done_score" :key="index">
						<p class="f30px cl_dark">{{item.score}}</p>
						<p class="f16px cl_gray">{{item.aspect}}</p>
					</div>
				</div>
			</div>
			<div class="career_report_list">
				<div class="practice_title f20px cl_dark">评测评语</div>
				<div class="f16px cl_gray career_report_list_end" v-html="data.done_res"></div>
			</div>
		</div>
		<vfooter></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import careerHeader from '../../components/career_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'career_report',
		components: {
			publicHeader,
			careerHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				careerNav: 0,
				data: {
					assess_project_data: {},
				},
				id: "",
			}
		},
		mounted() {
			this.id = this.$route.query.id;
			this.getdetails();
		},
		methods: {
			getdetails () {
				this.$get("/api/assess/get_user_assess_project_log_show",{
					token: localStorage.getItem("token"),
					id: this.id,
				})
				.then(res => {
					res.data.done_res = res.data.done_res.replace(/\\n/g, '<br>');
					console.log(res.data.done_res)
					this.data = res.data;
				});
			},
			
		},
	}
</script>

<style>
</style>
